// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adhoc-landing.adhoc-scan {
  min-height: 100dvh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--ink, #152631);
}

.adhoc-scan .scan-logo-overlay {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 12;
  height: 40px;
  width: auto;
  max-width: min(260px, 55vw);
  object-fit: contain;
  pointer-events: none;
}

.adhoc-scan .scan-main {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.adhoc-scan .scan-content {
  flex: 1;
  min-height: 0;
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.adhoc-scan .scan-timer-wrap {
  display: none;
}

.adhoc-scan .scan-stage {
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: center;
  background: #000;
}

.adhoc-scan .scan-stop-mini {
  position: absolute;
  top: 20%;
  right: 12px;
  z-index: 20;
  margin: 0;
  padding: 4px 10px;
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: lowercase;
  color: rgba(255, 255, 255, 0.85);
  background: rgba(11, 20, 27, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 999px;
  cursor: pointer;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  transition: background 0.15s ease, border-color 0.15s ease;
}

.adhoc-scan .scan-stop-mini:hover {
  background: rgba(185, 28, 28, 0.75);
  border-color: rgba(252, 165, 165, 0.6);
  color: #fff;
}

.adhoc-scan .scan-stop-mini:active {
  transform: scale(0.97);
}

.adhoc-scan .scan-video-wrap {
  position: absolute;
  inset: 0;
  overflow: hidden;
  background: #000;
}

.adhoc-scan .scan-control-float {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 18;
  padding: 12px 16px max(16px, env(safe-area-inset-bottom));
  background: linear-gradient(to top, rgba(11, 20, 27, 0.92) 0%, rgba(11, 20, 27, 0.55) 55%, transparent 100%);
  box-sizing: border-box;
}

.adhoc-scan .scan-control-float > div {
  width: 100%;
}

.adhoc-scan .scan-control-float button {
  width: 100%;
  border-radius: 999px;
  padding: 16px 28px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.35);
}

.adhoc-scan .scan-camera-hint {
  position: absolute;
  top: 68px;
  left: 16px;
  right: 16px;
  z-index: 15;
  margin: 0;
  padding: 0;
  font-family: var(--font-body);
  font-size: 13px;
  font-weight: 500;
  color: #fff;
  text-align: center;
  line-height: 1.45;
  text-shadow:
    0 1px 4px rgba(0, 0, 0, 0.85),
    0 0 12px rgba(0, 0, 0, 0.5);
  box-sizing: border-box;
  pointer-events: none;
}

.adhoc-scan .scan-loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  background: var(--panel);
  padding: 20px;
  text-align: center;
}

.adhoc-scan .scan-loading-spinner {
  width: 44px;
  height: 44px;
  border: 3px solid var(--panel-line);
  border-top-color: var(--teal);
  border-radius: 50%;
  animation: adhoc-scan-spin 0.9s linear infinite;
}

.adhoc-scan .scan-loading-title {
  margin: 0;
  font-family: var(--font-body);
  font-size: 16px;
  font-weight: 600;
  color: var(--ink);
  max-width: 300px;
}

.adhoc-scan .scan-loading-sub {
  margin: 0;
  font-family: var(--font-body);
  font-size: 13px;
  font-weight: 500;
  color: var(--muted);
  max-width: 300px;
}

.adhoc-scan .scan-enable-camera-btn {
  margin-top: 8px;
  min-width: 200px;
}

.adhoc-scan.adhoc-scan-measuring .scan-measuring-bar {
  display: flex;
}

.adhoc-scan .scan-measuring-bar {
  display: none;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  padding: 12px 16px 14px;
  background: rgba(11, 20, 27, 0.95);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  flex-shrink: 0;
}

.adhoc-scan .scan-measuring-timer {
  width: 100%;
}

.adhoc-scan .scan-measuring-label {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--teal, #3F9C8C);
  margin: 0;
}

.adhoc-scan.adhoc-scan-measuring .scan-control-float {
  display: none;
}

.adhoc-scan.adhoc-scan-measuring .scan-stage {
  flex: 1;
}

@keyframes adhoc-scan-spin {
  to { transform: rotate(360deg); }
}

@media (min-width: 768px) {
  .adhoc-scan .scan-stage {
    max-width: none;
    margin: 0;
    width: 100%;
    border-radius: 0;
    overflow: hidden;
  }

  .adhoc-scan .scan-video-wrap {
    border-radius: 0;
  }

  .adhoc-scan .scan-control-float {
    padding: 16px 24px 24px;
  }

  .adhoc-scan .scan-control-float button {
    padding: 18px 32px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/adhoc/scan.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,aAAa;EACb,WAAW;EACX,eAAe;EACf,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,kCAAkC;EAClC,2CAA2C;EAC3C,oBAAoB;EACpB,eAAe;EACf,0BAA0B;EAC1B,kCAAkC;EAClC,0DAA0D;AAC5D;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,yDAAyD;EACzD,4GAA4G;EAC5G,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,SAAS;EACT,UAAU;EACV,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB;;+BAE6B;EAC7B,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,wBAAwB;EACxB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,6BAA6B;EAC7B,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,uBAAuB;EACvB,kCAAkC;EAClC,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE;IACE,eAAe;IACf,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".adhoc-landing.adhoc-scan {\n  min-height: 100dvh;\n  height: 100dvh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: var(--ink, #152631);\n}\n\n.adhoc-scan .scan-logo-overlay {\n  position: absolute;\n  top: 16px;\n  left: 16px;\n  z-index: 12;\n  height: 40px;\n  width: auto;\n  max-width: min(260px, 55vw);\n  object-fit: contain;\n  pointer-events: none;\n}\n\n.adhoc-scan .scan-main {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.adhoc-scan .scan-content {\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n  max-width: none;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.adhoc-scan .scan-timer-wrap {\n  display: none;\n}\n\n.adhoc-scan .scan-stage {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  background: #000;\n}\n\n.adhoc-scan .scan-stop-mini {\n  position: absolute;\n  top: 20%;\n  right: 12px;\n  z-index: 20;\n  margin: 0;\n  padding: 4px 10px;\n  font-family: var(--font-mono);\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: lowercase;\n  color: rgba(255, 255, 255, 0.85);\n  background: rgba(11, 20, 27, 0.55);\n  border: 1px solid rgba(255, 255, 255, 0.22);\n  border-radius: 999px;\n  cursor: pointer;\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.adhoc-scan .scan-stop-mini:hover {\n  background: rgba(185, 28, 28, 0.75);\n  border-color: rgba(252, 165, 165, 0.6);\n  color: #fff;\n}\n\n.adhoc-scan .scan-stop-mini:active {\n  transform: scale(0.97);\n}\n\n.adhoc-scan .scan-video-wrap {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n  background: #000;\n}\n\n.adhoc-scan .scan-control-float {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 18;\n  padding: 12px 16px max(16px, env(safe-area-inset-bottom));\n  background: linear-gradient(to top, rgba(11, 20, 27, 0.92) 0%, rgba(11, 20, 27, 0.55) 55%, transparent 100%);\n  box-sizing: border-box;\n}\n\n.adhoc-scan .scan-control-float > div {\n  width: 100%;\n}\n\n.adhoc-scan .scan-control-float button {\n  width: 100%;\n  border-radius: 999px;\n  padding: 16px 28px;\n  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.35);\n}\n\n.adhoc-scan .scan-camera-hint {\n  position: absolute;\n  top: 68px;\n  left: 16px;\n  right: 16px;\n  z-index: 15;\n  margin: 0;\n  padding: 0;\n  font-family: var(--font-body);\n  font-size: 13px;\n  font-weight: 500;\n  color: #fff;\n  text-align: center;\n  line-height: 1.45;\n  text-shadow:\n    0 1px 4px rgba(0, 0, 0, 0.85),\n    0 0 12px rgba(0, 0, 0, 0.5);\n  box-sizing: border-box;\n  pointer-events: none;\n}\n\n.adhoc-scan .scan-loading-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 20;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  background: var(--panel);\n  padding: 20px;\n  text-align: center;\n}\n\n.adhoc-scan .scan-loading-spinner {\n  width: 44px;\n  height: 44px;\n  border: 3px solid var(--panel-line);\n  border-top-color: var(--teal);\n  border-radius: 50%;\n  animation: adhoc-scan-spin 0.9s linear infinite;\n}\n\n.adhoc-scan .scan-loading-title {\n  margin: 0;\n  font-family: var(--font-body);\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--ink);\n  max-width: 300px;\n}\n\n.adhoc-scan .scan-loading-sub {\n  margin: 0;\n  font-family: var(--font-body);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--muted);\n  max-width: 300px;\n}\n\n.adhoc-scan .scan-enable-camera-btn {\n  margin-top: 8px;\n  min-width: 200px;\n}\n\n.adhoc-scan.adhoc-scan-measuring .scan-measuring-bar {\n  display: flex;\n}\n\n.adhoc-scan .scan-measuring-bar {\n  display: none;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 10px;\n  padding: 12px 16px 14px;\n  background: rgba(11, 20, 27, 0.95);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  flex-shrink: 0;\n}\n\n.adhoc-scan .scan-measuring-timer {\n  width: 100%;\n}\n\n.adhoc-scan .scan-measuring-label {\n  font-family: var(--font-mono);\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--teal, #3F9C8C);\n  margin: 0;\n}\n\n.adhoc-scan.adhoc-scan-measuring .scan-control-float {\n  display: none;\n}\n\n.adhoc-scan.adhoc-scan-measuring .scan-stage {\n  flex: 1;\n}\n\n@keyframes adhoc-scan-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (min-width: 768px) {\n  .adhoc-scan .scan-stage {\n    max-width: none;\n    margin: 0;\n    width: 100%;\n    border-radius: 0;\n    overflow: hidden;\n  }\n\n  .adhoc-scan .scan-video-wrap {\n    border-radius: 0;\n  }\n\n  .adhoc-scan .scan-control-float {\n    padding: 16px 24px 24px;\n  }\n\n  .adhoc-scan .scan-control-float button {\n    padding: 18px 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
